import React from 'react';

import * as styles from './Tabs.styles';

export interface TabLink {
  href: string;
  id: string;
  label: string;
}

export interface TabsProps {
  activeId: string;
  ariaLabel: string;
  tabs: TabLink[];
}

/** Each tab is its own page, so the row is navigation rather than an ARIA tablist. */
export const Tabs = ({ activeId, ariaLabel, tabs }: TabsProps) => (
  <nav aria-label={ariaLabel}>
    <ul css={styles.tabList}>
      {tabs.map(({ href, id, label }) => (
        <li key={id}>
          <a aria-current={id === activeId ? 'page' : undefined} css={styles.tabLink} href={href}>
            {label}
          </a>
        </li>
      ))}
    </ul>
  </nav>
);
